<ejs-autocomplete #autocomplete
                  [id]="id"
                  placeholder="{{placeholder | translate}}"
                  autofill="true"
                  [dataSource]="data"
                  [fields]="fields"
                  [allowFiltering]="true"
                  [allowObjectBinding]="allowObjectBinding"
                  [(value)]="outputValue"
                  highlight = "true"
                  [cssClass]="cssClass"
                  [enabled]="enabled"
                  [minLength]="minLength"
                  (blur)="onBlur()"></ejs-autocomplete>
